import __mod from "react-dom/client"
export default __mod
export const createRoot = __mod["createRoot"]
export const hydrateRoot = __mod["hydrateRoot"]
export const version = __mod["version"]
